import React, { useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  TextField,
  MenuItem,
  Button,
  Stack,
  Divider,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { HexColorPicker, HexColorInput } from "react-colorful";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { createStyleDesign } from '../../apis/apiList/styleDesignApi';
import { useApp } from '../../context/AppContext';
import { useMessage } from '../../context/MessageContext';

const ColorSchema = Yup.object().shape({
  colorName: Yup.string().required('Color name is required'),
  colorType: Yup.string().required('Color type is required'),
  // colorHex: Yup.mixed().required('Color hex is required')
});

const AddColor = ({isOpen, organization, onClose, setColorName, setColorType, handleFileChange, fileName, updateList }) => {

  const [color, setColor] = useState("#aabbcc");
  const [file, setFile] = useState('');
  const { userDetails } = useApp();
  const [isLoading, setIsLoading] = useState(false);
  const { showMessage } = useMessage();

  const handleSubmit = async (name, type, hex) => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("name", name);
    formData.append("type", type);
    formData.append("organizationId", organization._id);
    formData.append("designType", "color");
    formData.append("folderid", organization.boxFolderId);
    // formData.append("userId", userDetails._id);
    formData.append("hex", hex);
    try {
      const response = await createStyleDesign(formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "x-access-token": userDetails?.jwtToken,
        },
      });
      console.log("response", response);
      if (response.success) {
        updateList(response.data?.style?.colors || [], 'colors');
        showMessage(response.message, "success");
      }
      onClose();
    } catch (err) {
      console.error("Error uploading Color:", err);
      // Handle error (e.g., show a message to the user)
      showMessage(
        err?.response?.data?.message || "Internal server issue",
        "error"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          maxWidth: "90%",
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          sx={{ px: 4, py: 2 }}
          alignItems={'center'}
        >
          <Typography variant="h3">Add Color</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>

        <Divider />

        <Formik
          initialValues={{
            colorName: "",
            colorType: "",
            // colorHex: null,
          }}
          validationSchema={ColorSchema}
          onSubmit={(values) => {
            // setColorName(values.colorName);
            // setColorType(values.colorType);
            // handleFileChange({ target: { files: [values.colorHex] } });
            // onClose();
            // setFile(values.fontFile);
            console.log("values", values);
            handleSubmit(values.colorName, values.colorType, color);
          }}
        >
          {({ errors, touched, setFieldValue, values }) => (
            <Form>
              <Box
                display="flex"
                flexDirection="column"
                gap={2}
                sx={{ p: 4, pt: 3 }}
              >
                <Field
                  as={TextField}
                  name="colorName"
                  label="Color Name"
                  variant="outlined"
                  fullWidth
                  error={touched.colorName && Boolean(errors.colorName)}
                  helperText={touched.colorName && errors.colorName}
                />

                <Field
                  as={TextField}
                  select
                  name="colorType"
                  label="Select Color Type"
                  variant="outlined"
                  fullWidth
                  error={touched.colorType && Boolean(errors.colorType)}
                  helperText={touched.colorType && errors.colorType}
                >
                  <MenuItem value="" disabled>
                    Select Color Type
                  </MenuItem>
                  <MenuItem value="primary">Primary</MenuItem>
                  <MenuItem value="secondary">Secondary</MenuItem>
                </Field>

                <Box>
                  <Typography variant="subtitle1" fontWeight={500} mb={1}>
                    Color Picker
                  </Typography>
                  <Box display="flex" flexDirection={'column'} alignItems="center" gap={3}>

                    <HexColorPicker color={color} onChange={setColor} />
                    <HexColorInput color={color} onChange={setColor} prefixed alpha />
                  </Box>
                </Box>
                
                <Box display="flex" justifyContent="flex-end" mt={2}>
                  <Button type="submit" variant="contained" disabled={isLoading}>
                    {isLoading ? "Saving..." : "Save Changes"}
                  </Button>
                </Box>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
};

export default AddColor;
